import locale from "@bonliva-crm/locale";

export function formatRegionLabel(label: string) {
  // todo: migrate all "Bonliva Care" values to "Bonliva Care:*" and remove this hack
  if (label === "Bonliva Care") {
    return "Bonliva Care";
  }
  // end of hack

  const [country, region] = label.split(":");
  if (label === `${country}:*`) {
    return locale.countries[country];
  }

  return region;
}

type Option = {
  label: string;
  value: string;
};

export function getRegions(
  regions: Map<string, string[]>,
  availableInCountries: string[]
): Option[] {
  const entries = Array.from(regions.entries())
    .filter((x) => availableInCountries.includes(x[0]))
    .sortBy((x) => !x[0].startsWith("Sweden"));

  const options: Option[] = [];

  for (const entry of entries) {
    const country = entry[0];
    options.push({ label: locale.countries[country], value: `${country}:*` });

    for (const region of entry[1]) {
      options.push({ label: region, value: `${country}:${region}` });
    }
  }

  return options;
}
